// ui/discoveryNotification.js
// Discovery notification popup for Tome of Echoes

import { getItemName, getItemIcon, getItemColor } from '../data/items/index.js';

let notificationQueue = [];
let isShowingNotification = false;

/**
 * Show a discovery notification for a newly discovered item
 * @param {string} itemId - The discovered item ID
 * @param {number} discoveryNumber - Which discovery this is (e.g., 47th item discovered)
 */
export function showDiscoveryNotification(itemId, discoveryNumber) {
    // Queue the notification
    notificationQueue.push({ itemId, discoveryNumber });

    // Process queue if not already showing
    if (!isShowingNotification) {
        processNextNotification();
    }
}

/**
 * Process the next notification in the queue
 */
function processNextNotification() {
    if (notificationQueue.length === 0) {
        isShowingNotification = false;
        return;
    }

    isShowingNotification = true;
    const { itemId, discoveryNumber } = notificationQueue.shift();

    const itemName = getItemName(itemId);
    const itemIcon = getItemIcon(itemId);
    const itemColor = getItemColor(itemId);

    // Create notification element
    const notification = document.createElement('div');
    notification.className = 'discovery-notification';
    notification.innerHTML = `
        <div class="discovery-header">
            <span class="discovery-label">📖 New Discovery!</span>
            <span class="discovery-number">#${discoveryNumber}</span>
        </div>
        <div class="discovery-item">
            <div class="discovery-icon" style="background-color: ${itemColor};">
                ${itemIcon}
            </div>
            <span class="discovery-name">${itemName}</span>
        </div>
    `;

    document.body.appendChild(notification);

    // Trigger animation
    requestAnimationFrame(() => {
        notification.classList.add('show');
    });

    // Remove after delay
    setTimeout(() => {
        notification.classList.remove('show');
        notification.classList.add('hide');

        setTimeout(() => {
            notification.remove();
            // Process next notification
            processNextNotification();
        }, 300);
    }, 2500);
}

export default {
    showDiscoveryNotification
};
